module.exports = __webpack_public_path__ + "img/profile .adf076bb.png";